import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainJA() {
  const articleData = {
    title: 'なぜ一部の人は私たちを疲れさせるのか？（AIが解説）',
    description: 'テキストで感情的に疲れ果てていませんか？Toxic DetectorのAIが、あなたの関係における一方的なコミュニケーションと微妙な感情的消耗パターンをどのように検出するかを学びましょう。',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Toxic Detector 編集部'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '人間関係における感情的消耗とは何ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '感情的消耗は、誰かとのやり取りが常にあなたを疲れさせ、イライラさせ、または罪悪感を感じさせる場合に発生します。これは、一方的または操作的なコミュニケーションが原因であることがよくあります。'
      }
    }, {
      '@type': 'Question',
      name: 'テキストメッセージはどのようにして感情的消耗を引き起こすのですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '繰り返される一方的なメッセージ、罪悪感の誘発、一貫性のない関与、または微妙な批判は、大きな対立がなくてもあなたを疲れさせる可能性があります。'
      }
    }, {
      '@type': 'Question',
      name: 'AIは誰が私の感情的エネルギーを奪っているかを検出できますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい。Toxic Detectorはテキストパターン、トーン、関与を分析して、一方的、操作的、または消耗させる行動を即座に強調します。'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/ja/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('リンクがクリップボードにコピーされました！');
    }
  };
  return <>
      <MetaTags title="なぜ一部の人は私たちを疲れさせるのか？ — AIが感情的消耗を解説 | ToxicDetector" description="テキストで感情的に疲れ果てていませんか？Toxic DetectorのAIが一方的なコミュニケーションと微妙な感情的消耗パターンを検出する方法を学びましょう。" keywords="人間関係の感情的消耗, 一方的なテキストパターン, エネルギーバンパイア, AI感情分析" canonical={`https://toxicdetector.com/ja/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-7337" data-mp="1896cq3s0weg7" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-7338" data-mp="kk3izxk46v5c">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-7339" data-mp="klemrxdk82wg">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-7340" data-mp="gkcopjvdpww2">
            <div className="flex items-center justify-between" data-id="element-7341" data-mp="2s4k89409bwxu">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-7342" data-mp="2w6e5117c0gsq">
                <span className="text-2xl" data-id="element-7343" data-mp="2w8ry54igbixn">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-7344" data-mp="3171v9knqktlw">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-7345" data-mp="28i4czhjiywt5">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-7346" data-mp="28fi5fhwmwhax">
                  無料スキャン
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="記事を共有" data-id="element-7347" data-mp="2n8bu9txsq9s9">
                  <Share2 size={20} className="text-gray-600" data-id="element-7348" data-mp="1unlg1lmcoli8" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-7349" data-mp="3sejyrthcj8d3">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-7350" data-mp="9z9cyybodl0l">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7351" data-mp="56py7y194ju7" />
            ホームに戻る
          </Link>

          <header className="mb-16" data-id="element-7352" data-mp="ey41mgwbq3sm">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-7353" data-mp="syeu1oda7qfw">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-7354" data-mp="nztuzs9rnct1">
              <time dateTime={articleData.publishDate} data-id="element-7355" data-mp="2uqta0hw9mkto">
                {new Date(articleData.publishDate).toLocaleDateString('ja-JP', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7356" data-mp="1a89192tn0pmt">•</span>
              <span data-id="element-7357" data-mp="1a6xv4wcpz5sj">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-7358" data-mp="wft5mn32ftvx">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="AIがテキストメッセージの感情的消耗パターンを分析" className="w-full rounded-2xl shadow-lg" data-id="element-7359" data-mp="wehz4fi8k814" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-7360" data-mp="ri10ushbodab">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-7361" data-mp="dii754p9d4hj">目次</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-7362" data-mp="hisa08hr7es6">
              <li data-id="element-7363" data-mp="hkvaxnkg2sbo">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7364" data-mp="27vr8283qnho6">
                  「いつも何かがおかしい」友人
                </a>
              </li>
              <li data-id="element-7365" data-mp="3kvky1so99rqz">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7366" data-mp="3krx5owujrbdu">
                  何かが必要なときだけテキストを送ってくる人
                </a>
              </li>
              <li data-id="element-7367" data-mp="36va7kqquyf6c">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7368" data-mp="36vtelceyzj5l">
                  感情のない「ドライテキスター」
                </a>
              </li>
              <li data-id="element-7369" data-mp="3us7k2ksbioul">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7370" data-mp="3urnz0v7dfkcc">
                  ゴースト＆リターンアーティスト
                </a>
              </li>
              <li data-id="element-7371" data-mp="r4nm30wrvb5s">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7372" data-mp="r577wspjmjp3">
                  微妙な罪悪感トリッパー
                </a>
              </li>
              <li data-id="element-7373" data-mp="ym3qdjabcxoy">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7374" data-mp="ynojd4gzc8kp">
                  偽のサポーター
                </a>
              </li>
              <li data-id="element-7375" data-mp="17l78ajxqv71v">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-7376" data-mp="1cmeiepnd0ibp">
                  「健康的-有毒」コンボ
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-7377" data-mp="1measkz2pzywa">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-7378" data-mp="1rbkew5utbufw">
              誰かにテキストを送って、会話が喧嘩でなくても、後で疲れたり、イライラしたり、奇妙に罪悪感を感じたりしたことはありますか？それは
              <strong className="text-gray-900" data-id="element-7379" data-mp="20bz0z7flpdkg">
                人間関係における感情的消耗
              </strong>
              であり、あなたが思っているよりも一般的です。
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-7380" data-mp="2llmf91kwss80">
              それは<strong className="text-gray-900" data-id="element-7381" data-mp="2gombixbj81k2">一方的なテキスト</strong>
              パターンと微妙な操作です。当社の
              <strong className="text-gray-900" data-id="element-7382" data-mp="2vldd9d8ohpcu">AI分析</strong>
              はこれらのパターンを即座に読み取ります。
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-7383" data-mp="2qn2311eh1cu3">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7384" data-mp="22w6figh1t3sn">
                1️⃣ 「いつも何かがおかしい」友人
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7385" data-mp="1xyo3gh7qi8gf">
                携帯電話をチェックしてすぐに感じます：
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7386" data-mp="2coc6bmvkdf69">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7387" data-mp="27u7xey2qmx2j">
                  「ああ、神様...今度は何？」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7388" data-mp="1f73r8prwscp6">
                すべてのメッセージはストレス、混沌、または不満です。AIはこれを
                <strong className="text-gray-900" data-id="element-7389" data-mp="3qtxiqanlau9p">一方的な感情的負荷</strong>
                としてフラグを立てます。
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-7390" data-mp="3vm8h392om805">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7391" data-mp="3gx2j1ofkyntu">
                2️⃣ 何かが必要なときだけテキストを送ってくる人
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-7392" data-mp="3lt19riodshxf">
                <p className="mb-4 text-lg text-gray-700" data-id="element-7393" data-mp="dg3ryudq1z5v">
                  <strong className="text-gray-900" data-id="element-7394" data-mp="ieniz976a153">決して：</strong>「元気？」
                </p>
                <p className="text-lg text-gray-700" data-id="element-7395" data-mp="4f5p4ff0rxov">
                  <strong className="text-gray-900" data-id="element-7396" data-mp="4gp6688i2crp">いつも：</strong>
                  「...できる？」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7397" data-mp="2p53dcacn06o0">
                AIはこれを
                <strong className="text-gray-900" data-id="element-7398" data-mp="2t6gj6kfqc9ux">
                  取引的なコミュニケーション
                </strong>
                として検出します。
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-7399" data-mp="24pysicqt4hlw">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7400" data-mp="29lxb1jpgf5ee">
                3️⃣ 感情のない「ドライテキスター」
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7401" data-mp="1vthgl7amcfp3">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7402" data-mp="1zvch49kq6p1t">
                  "ok."
                  <br data-id="element-7403" data-mp="1lw2yz4cylkv7" />
                  "K."
                  <br data-id="element-7404" data-mp="1qx0gdeq5aavn" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-7405" data-mp="1cwpqof0kn2c2">
                AIはこれらの
                <strong className="text-gray-900" data-id="element-7406" data-mp="1gyba6j7m2ev8">切断シグナル</strong>
                を即座にキャッチします。
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-7407" data-mp="37ah3fne762bq">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7408" data-mp="378w8hwnz0hdc">
                4️⃣ ゴースト＆リターンアーティスト
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7409" data-mp="zo79h7704qdv">
                3週間姿を消します。戻ってくるときは：
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7410" data-mp="voykefmwpgon">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7411" data-mp="19fk1pzwppikf">
                  「やあ 😁」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7412" data-mp="14m8xm6jabfw7">
                AIはこれを
                <strong className="text-gray-900" data-id="element-7413" data-mp="1jesvarno0v69">一貫性のない関与</strong>
                としてマークします。
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-7414" data-mp="1se64dj7vnhqg">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7415" data-mp="1sbjx7kowf48r">
                5️⃣ 微妙な罪悪感トリッパー
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7416" data-mp="3u4hkl0zwp4mb">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7417" data-mp="3p66d2wx33679">
                  「じゃあ一人で行くよ...」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-7418" data-mp="1t4conevlhtna">
                AIはこれを
                <strong className="text-gray-900" data-id="element-7419" data-mp="1y2o1lyh6sk9q">受動的な操作</strong>
                としてマークします。
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-7420" data-mp="233c0157qw3dz">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7421" data-mp="273ce2oqxmcki">
                6️⃣ 偽のサポーター
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-7422" data-mp="2bzjk0hjbvo2g">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-7423" data-mp="2gyw9la1l398q">
                  「つまり、君は時々過剰反応する傾向があるってこと。」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7424" data-mp="2qqtlkj0f258i">
                AIは<strong className="text-gray-900" data-id="element-7425" data-mp="2us5fv1u8jen1">隠された批判</strong>
                を検出します。
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-7426" data-mp="2zqgpbbgmbn4q">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7427" data-mp="o3v8dbtl7ys8">
                7️⃣ 「健康的-有毒」コンボ
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-7428" data-mp="j4ikcnqzclo2">
                <p className="mb-4 text-lg text-gray-700" data-id="element-7429" data-mp="f2opwx7dodwc">
                  ある日は暖かい。ある日は冷たい。
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-7430" data-mp="a5ojgl6m994p">
                AIはこのパターンを
                <strong className="text-gray-900" data-id="element-7431" data-mp="16tuupqy1mzry">不安定な感情リズム</strong>
                としてラベル付けします。
              </p>
            </section>

            <section className="mb-16" data-id="element-7432" data-mp="y22o5rc54asn">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7433" data-mp="y110mndxtvu1">
                なぜこれが重要なのか
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-7434" data-mp="t2pqebjqdjba">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-7435" data-mp="1qk6nfeyd8haf">
                  パターンが見えたら、次のことができます：
                </p>
                <ul className="space-y-5" data-id="element-7436" data-mp="15bmga7q6scbf">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-7437" data-mp="15at6syzuf8pl">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-7438" data-mp="1ac0fr1dq2dxu">
                      ✓
                    </span>
                    <span data-id="element-7439" data-mp="wdisf4rqb3gg">エネルギーを守る</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-7440" data-mp="11bbze00uw1hs">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-7441" data-mp="1ozva0m7doqd1">
                      ✓
                    </span>
                    <span data-id="element-7442" data-mp="1t0xa1594d6g2">境界線を設定する</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-7443" data-mp="1fb3k0jlvog4r">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-7444" data-mp="1k954n8yycnic">
                      ✓
                    </span>
                    <span data-id="element-7445" data-mp="27y7jk927c295">罪悪感を感じるのをやめる</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-7446" data-mp="2crsjw7r9p8bi">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-7447" data-mp="2m3pztmlc41gi">
                よくある質問
              </h2>
              <div className="space-y-5" data-id="element-7448" data-mp="2i2eie4cm6mje">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-7449" data-mp="2vtt44ixwp1u5" data-mpi={index}>
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-7450" data-mp="2365j52sq496z">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-7451" data-mp="1z6ejsap4skqu">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-7452" data-mp="3ohx9t4gh9ewu">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-7453" data-mp="3jiu3lgorh2na">
              😮‍💨 疲れを感じるのをやめましょう。
              <br data-id="element-7454" data-mp="3rkbjr26l9u9z" />
              はっきりと見始めましょう。
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-7455" data-mp="3vleuxbdoz24v">
              推測するのはやめましょう。テキストをToxic
              Detectorにアップロードして、即座に毒性スコアを取得してください。
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-7456" data-mp="9f8ar6di4y4a">
              <p className="font-bold text-2xl" data-id="element-7457" data-mp="37xdkty0v7dnc">
                "⚠️ 感情的消耗：高。一方的なコミュニケーションを検出。"
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-7458" data-mp="3cvyjvu4drra7">
              今すぐチャットをスキャン →
            </Link>
          </div>

          <div className="mt-20" data-id="element-7459" data-mp="2p5ug9mr6zrj7">
            <RelatedBlogPosts posts={[{
            title: 'なぜ一部の人は私たちを疲れさせるのか？パート2',
            description: '過剰な説明や知ったかぶりなど、エネルギーを奪うより微妙なパターン。',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: '受動的攻撃的なテキストへの究極のガイド',
            description: 'テキストメッセージでの受動的攻撃的な行動と隠された操作を見つけます。',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-7460" data-mp="2u57dn1fowh01" />
          </div>

          <div className="mt-16 text-center" data-id="element-7461" data-mp="1yvtyovafq8hc">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-7462" data-mp="1yu0urnr7i2d1">
              <Share2 size={20} data-id="element-7463" data-mp="1jyl65y9eayo1" />
              この記事を共有
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-7464" data-mp="1fwpx27l83gzp">
          <div className="max-w-4xl mx-auto px-6" data-id="element-7465" data-mp="1fzlt1qdifvli">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-7466" data-mp="33uz2u88b31qs">
              <p className="text-gray-400 text-sm" data-id="element-7467" data-mp="38tk3g8rgznfr">
                © {new Date().getFullYear()} ToxicDetector. 全著作権所有。
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}